import { validateMobileNumber } from "utilities/generalUtility";

import { PhoneNumberEditor } from "./components/phoneNumberEditor";
import { DatePickerEditor } from "./components/datePickerEditor";
import {
  DATE_FIELDS,
  HIRE_TYPES,
  STATUS_LIST,
  dateCellClass,
  dateTooltipValueGetter,
  dateValueGetter,
  dateValueSetter,
  editableField,
  emailCellClass,
  emailTooltipValueGetter,
  formatDateValue,
  formatPhoneNumber,
  getAllowedSubStatuses,
  recruiterCellClass,
  recruiterEditorParams,
  recruiterTooltipValueGetter,
  requiredField,
  selectCellClass,
  selectDisplayValue,
  selectTooltipValueGetter,
  statusValueSetter,
  subStatusEditorParams,
  toSelectParams,
  validatedField,
} from "./helpers";

const selectField = (
  headerName,
  dataKey,
  items,
  { labelKey = "name", idKey = "id", editorParams, required } = {},
) => ({
  ...editableField(headerName, dataKey),
  cellRenderer: ({ data }) =>
    selectDisplayValue(data, dataKey, headerName, items, labelKey, idKey),
  getQuickFilterText: ({ data }) =>
    selectDisplayValue(data, dataKey, headerName, items, labelKey, idKey),
  tooltipValueGetter: selectTooltipValueGetter(dataKey, headerName, items, {
    labelKey,
    idKey,
    required,
  }),
  cellClass: selectCellClass(dataKey, headerName, items, { idKey, required }),
  cellEditor: "agRichSelectCellEditor",
  cellEditorParams:
    editorParams || (() => toSelectParams(items, labelKey, idKey)),
});

const recruiterField = (headerName, dataKey, recruiters) => ({
  ...selectField(headerName, dataKey, recruiters, {
    editorParams: recruiterEditorParams(dataKey, recruiters),
  }),
  cellClass: recruiterCellClass(dataKey, recruiters),
  tooltipValueGetter: recruiterTooltipValueGetter(dataKey, recruiters),
});

const dateField = (headerName) => ({
  headerName,
  field: headerName,
  editable: true,
  valueGetter: dateValueGetter(headerName),
  valueSetter: dateValueSetter(headerName),
  cellRenderer: ({ value }) => formatDateValue(value),
  getQuickFilterText: ({ value }) => formatDateValue(value),
  tooltipValueGetter: dateTooltipValueGetter(headerName),
  cellClass: dateCellClass(headerName),
  cellEditor: DatePickerEditor,
  cellEditorPopup: false,
});

export const getColumns = ({ jobs, classList, recruiters, lookupData }) => [
  {
    headerName: "ID",
    field: "id",
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    ...editableField("First Name"),
    ...requiredField("First Name is required"),
    getQuickFilterText: ({ data }) => data["First Name"],
  },
  {
    ...editableField("Last Name"),
    ...requiredField("Last Name is required"),
  },
  {
    ...editableField("Email"),
    cellClass: emailCellClass,
    tooltipValueGetter: emailTooltipValueGetter,
  },
  {
    ...editableField("Mobile Number"),
    ...validatedField(validateMobileNumber, "Please enter correct number"),
    valueGetter: ({ data }) =>
      (data["Mobile Number"] ?? "").replace(/^\+1/, ""),
    cellRenderer: ({ value }) => formatPhoneNumber(value),
    cellEditor: PhoneNumberEditor,
  },
  selectField("Candidate Type", "Candidate Type", HIRE_TYPES, {
    labelKey: "label",
    idKey: "value",
    required: true,
  }),
  selectField("Job Title", "Job Source ID", jobs, { labelKey: "title" }),
  selectField("Class Title", "Class ID", classList, { labelKey: "title" }),
  editableField("ATS ID"),
  selectField(
    "Candidate Status",
    "Candidate Status ID",
    lookupData.candidateStatus,
  ),
  selectField("Source", "Source ID", lookupData.source),
  recruiterField("First Recruiter", "First Recruiter ID", recruiters),
  recruiterField("Second Recruiter", "Second Recruiter ID", recruiters),
  {
    ...selectField("Status", "Status ID", STATUS_LIST),
    valueSetter: statusValueSetter,
  },
  {
    ...selectField("Sub Status", "Sub Status ID", getAllowedSubStatuses),
    cellEditorParams: subStatusEditorParams,
  },
  ...DATE_FIELDS.map(dateField),
];
